import { Button, Table } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";
import ContactsDialog from "../Dialogs/ContactsDialog";

interface ContactsListingProps {
	buildingId: string;
}

interface Contact {
	contacts_id: string;
	buildings_id: string;
	date_entered: string;
	email: string;
	first_name: string;
	is_primary: boolean;
	last_name: string;
	phone_number: string;
	send_arrival_texts: boolean;
	send_callback_texts: boolean;
	send_maint_texts: boolean;
	send_nuisance_texts: boolean;
	send_repair_texts: boolean;
	send_sale_texts: boolean;
	send_violation_texts: boolean;
}

export default function ContactsListing(props: ContactsListingProps) {
	const [contacts, setContacts] = React.useState([] as Array<Contact>);
	const [cId, setCid] = React.useState("");
	const [dialog, setDialog] = React.useState(false);

	React.useEffect(() => {
		getData();
	}, [props.buildingId]);

	const getData = () => {
		fetch("Building/GetContacts", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ buildingsId: props.buildingId }),
		})
			.then((x) => x.json())
			.then((x) => setContacts(x as Array<Contact>));
	};
	return (
		<>
			{dialog && (
				<ContactsDialog
					buildingsId={props.buildingId}
					contactsId={cId}
					close={() => {
						getData();
						setDialog(false);
					}}
				/>
			)}
			<Button
				sx={{ mt: 1 }}
				onClick={() => {
					setCid("");
					setDialog(true);
				}}>
				Add Contact
			</Button>{" "}
			<Table stripe="even" hoverRow={true} sx={{ cursor: "pointer" }}>
				<thead>
					<tr>
						<th>First Name</th>
						<th>Last Name</th>
						<th>Phone Number</th>
						<th>Email</th>
						<th>Primary?</th>
					</tr>
				</thead>
				<tbody>
					{contacts.map((x) => {
						return (
							<tr
								onClick={() => {
									setCid(x.contacts_id);
									setDialog(true);
								}}>
								<td>{x.first_name}</td>
								<td>{x.last_name}</td>
								<td>{x.phone_number}</td>
								<td>{x.email}</td>
								<td>{Util.Formatter(x.is_primary, "L")}</td>
							</tr>
						);
					})}
				</tbody>
			</Table>
		</>
	);
}
